import { Component, OnInit } from "@angular/core";
import { Workflow } from "../core/model/workflow";
import { WorkflowService } from "../core/service/workflow.service";

@Component({
  selector: "app-workflow",
  templateUrl: "./workflow.component.html",
  styleUrls: ["./workflow.component.scss"],
})
export class WorkflowComponent implements OnInit {
  workflows: Workflow[];

  constructor(private _workflowService: WorkflowService) {}

  ngOnInit() {
    this.getWorkflows();
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
